
import ClubJoin from '~/components/organisms/clubs/ClubJoin.vue'
import ClubJoinCodeForm from '~/components/organisms/clubs/ClubJoinCodeForm.vue'

export default {
  components: { ClubJoin, ClubJoinCodeForm },

  props: {
    signupRoute: {
      type: [Object, String],
      default: () => ({ name: 'signup' }),
    },
  },

  data() {
    return {
      club: null,
      codeValue: null,
    }
  },

  computed: {
    open: {
      get() {
        return this.$store.getters['clubs/isDialogJoinClubOpen']
      },
      set(val) {
        this.$store.commit('clubs/setIsDialogJoinClubOpen', val)
      },
    },
  },

  watch: {
    /**
     * Clear club.
     * Clear form when dialog is not open.
     * @param {Boolean} val the dialog state.
     */
    open(val) {
      this.club = null
      if (val) {
        this.codeValue = null
      }
    },
  },

  methods: {
    forwardToSignUp() {
      this.open = false
      this.$store.commit('clubs/setClubToJoin', this.club)
      this.$router.push(this.signupRoute)
    },

    handleClubJoined(club) {
      this.$router.push({
        name: 'clubs-club_id',
        params: { club_id: club.id },
      })
      this.$store.commit('clubs/setSelected', club)

      this.open = false
    },

    setClub(values) {
      this.club = values
    },

    setCodeAndClearClub() {
      this.codeValue = this.club.code
      this.club = null
    },
  },
}
